import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationPage.css';

export default function MfaExpiredPage() {
  const navigate = useNavigate();

  return (
    <div className="registration-success-container">
      <div className="registration-success-card">
        <div className="registration-success-icon" style={{ color: '#c0392b' }}>✕</div>
        <h1>Session Expired</h1>
        <p className="registration-success-lead">
          Your login session expired. Please log in again to continue.
        </p>
        <button
          className="back-to-login-btn"
          onClick={() => navigate('/')}
        >
          Back to Log In
        </button>
      </div>
    </div>
  );
}
